import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [phone, setPhone] = useState('');
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function checkSessionAndProfile() {
      try {
        // Récupérer la session actuelle
        let { data: { session } } = await supabase.auth.getSession();

        // Si session expirée, essayer de la rafraîchir
        if (!session) {
          const { data, error } = await supabase.auth.refreshSession();
          if (error) throw error;
          session = data.session;
        }

        if (session && session.user) {
          const storedProfile = sessionStorage.getItem('userProfile');

          if (!storedProfile) {
            const { data, error } = await supabase
              .from('profiles')
              .select('*')
              .eq('id', session.user.id)
              .single();

            if (error) throw error;

            sessionStorage.setItem('userProfile', JSON.stringify(data));
          }
          navigate('/dispo');
        }
      } catch (err) {
        console.warn('Erreur chargement profil ou rafraîchissement session:', err);
      }
    }

    checkSessionAndProfile();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session && session.user) {
        navigate('/dispo');
      }
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [navigate]);

  const sendCode = async () => {
    setError('');
    if (!phone.startsWith('+')) {
      setError('Le numéro doit commencer par + suivi de l’indicatif');
      return;
    }
    const { error } = await supabase.auth.signInWithOtp({ phone });
    if (error) setError(error.message);
    else setSent(true);
  };

  const verifyCode = async () => {
    setError('');
    if (!/^\d{6}$/.test(code)) {
      setError('Le code doit contenir exactement 6 chiffres');
      return;
    }
    const { error } = await supabase.auth.verifyOtp({
      type: 'sms',
      token: code,
      phone,
    });
    if (error) setError(error.message);
    else navigate('/compte');
  };

  return (
    <div>
      <h2>Connexion</h2>
      {!sent ? (
        <>
          <input
            value={phone}
            onChange={e => setPhone(e.target.value)}
            placeholder="Numéro de téléphone (+33612345678)"
          />
          <button onClick={sendCode}>Envoyer le code</button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </>
      ) : (
        <>
          <p>Un code à 6 chiffres vient d’être envoyé au <b>{phone}</b></p>
          <input
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="Entrez le code"
            maxLength={6}
          />
          <button onClick={verifyCode}>Valider le code</button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </>
      )}
    </div>
  );
}
